export const parseStringFilter = (value) => {
  if (!value) return null;
  const match = String(value).match(/^string\((.+)\)$/i);
  return (match ? match[1] : value).toLowerCase();
};

export const paginate = (items, pageNumber = 1, pageSize = 12) => {
  const page = Math.max(Number(pageNumber) || 1, 1);
  const size = Math.max(Number(pageSize) || 12, 1);
  const start = (page - 1) * size;
  return items.slice(start, start + size);
};

export const searchItems = (items, query, fields) => {
  if (!query) return items;
  const term = String(query).trim().toLowerCase();
  if (!term) return items;

  return items.filter((item) =>
    fields.some((field) => {
      const value = field(item);
      return value && String(value).toLowerCase().includes(term);
    })
  );
};

export const getSortValue = (item, field) => {
  if (field === 'createdAt') {
    return new Date(item.createdAt || 0).getTime();
  }

  if (field === 'reservePrice') {
    const price = item.sale?.bids?.length
      ? item.sale.bids[item.sale.bids.length - 1].amount
      : item.sale?.reservePrice || item.sale?.price || item.reservePrice || item.price || '0';
    return Number(price);
  }

  if (field === 'spent') return Number(item.spent || 0);
  if (field === 'received') return Number(item.received || 0);

  return item[field];
};

export const sortItems = (items, sort = '-createdAt') => {
  if (!sort) return items;

  const direction = sort.startsWith('-') ? -1 : 1;
  const field = sort.replace(/^[-+]/, '');

  return [...items].sort((a, b) => {
    const aValue = getSortValue(a, field);
    const bValue = getSortValue(b, field);

    if (aValue === bValue) return 0;
    return aValue > bValue ? direction : -direction;
  });
};

export const wrapResponse = (data) => Promise.resolve({ data });

export const clone = (value) => JSON.parse(JSON.stringify(value));
